import JsZip from 'jszip';
import FileSaver from 'file-saver';

function downloadSkinZip(canvasBmpArray, svgComponentArray, fontData, fontName, skinName, size) {
    let fontDefs = `${fontName}.ttf\n[ ]\n${fontName}.ttf\n[ ]\n${fontName}.ttf\n[ ]\n${fontName}.ttf\n[ ]\n${fontName}.ttf\n[ ]\n${fontName}.ttf\n[ ]`
    let base64Array = [];

    for (let i = 0; i < canvasBmpArray.length; i++) {
        let canvasDataURL = canvasBmpArray[i].current.toDataURL("image/png", 1);
        base64Array.push(canvasDataURL.replace(/^data:image\/(png|jpg);base64,/, ""));
    }

    let zip = new JsZip();
    zip.file("readme.txt", "// Instructions for use:\n\n1. Extract/Unzip folder.\n2. Drag entire (extracted) folder into Serum 'Skins' folder (this is usually located in: Documents > Xfer > Serum Presets > Skins).\n\n// alpha version X.0.4 \n// Skin Generator for Serum VST was created by REXTR909. No affiliation with Xfer / Serum.");
    zip.file(`${svgComponentArray[0].fileName}.png`, base64Array[0], { base64: true });

    let fonts = zip.folder("Fonts");
    fonts.file(`${fontName}.ttf`, fontData);
    fonts.file("fontdefs.txt", fontDefs);

    let img = zip.folder(`${size}x`);

    for (let i = 0; i < base64Array.length; i++) {
        if (size === 1) {
            img.file(`${svgComponentArray[i].fileName}.png`, base64Array[i], { base64: true });
        }
        else {
            img.file(`${svgComponentArray[i].fileName2x}.png`, base64Array[i], { base64: true });
        }
    }

    zip.generateAsync({ type: "blob" }).then(content => {
        FileSaver.saveAs(content, `${skinName}.zip`);
    });
}

export default downloadSkinZip;